export default "__VITE_ASSET__DPXOI9Ox__"